document.addEventListener('DOMContentLoaded', function() {
  // Listen for add to cart form submissions
  const addToCartForms = document.querySelectorAll('form[action="/cart/add"]');
  
  addToCartForms.forEach(form => {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      
      const formData = new FormData(form);
      
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(response => response.json())
      .then(data => {
        // Redirect to checkout after successful add
        window.location.href = '/checkout';
      })
      .catch(error => {
        console.error('Error:', error);
      });
    });
  });
});